import { createContext, useEffect, useState } from "react";

export const ZGAContext = createContext();

export const ZGAProvider = ({ children }) => {
  // State to store user data
  const [user, setUser] = useState(null);
  // Function to retrieve user from localStorage on app load
  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
      localStorage.removeItem("user");
    }
  }, []);

  // Deals with loader appearance
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Deals with the opening and closing of the rules and fees modal
  const [currentModal, setCurrentModal] = useState(null);
  const openModal = (modalName) => setCurrentModal(modalName);
  const closeModal = () => setCurrentModal(null);

  // Deals with the success/failure modals of Auth pages
  const [successModal, setSuccessModal] = useState({
    isVisible: false,
    message: "",
    isSuccess: false,
    actionPath: null,
    pathText: "",
  });
  const showSuccessModal = (message, isSuccess, actionPath, pathText) => {
    setSuccessModal({
      isVisible: true,
      message,
      isSuccess,
      actionPath,
      pathText,
    });
  };
  const hideSuccessModal = () => {
    setSuccessModal({
      isVisible: false,
      message: "",
      isSuccess: false,
      actionPath: null,
      pathText: "",
    });
  };

  // Deals with the success/failure of registration
  const [rSModal, setRSModal] = useState({
    isVisible: false,
    isSuccess: false,
    message: "",
    currency: "",
    fee: 0,
  });
  const showRSModal = (isSuccess, message, paymentDetails = {}) => {
    setRSModal({ isVisible: true, isSuccess, message, ...paymentDetails  });
  };
  const hideRSModal = () => {
    setRSModal({ isVisible: false, isSuccess: false, message: "", currency: "", fee: 0 });
  };

  return (
    <ZGAContext.Provider
      value={{
        currentModal,
        openModal,
        closeModal,
        successModal,
        showSuccessModal,
        hideSuccessModal,
        isSubmitting,
        setIsSubmitting,
        user,
        setUser,
        rSModal,
        showRSModal,
        hideRSModal,
      }}
    >
      {children}
    </ZGAContext.Provider>
  );
};
